import { graphql } from 'gql/generated'

export const GET_SERVICES = graphql(`
  query GetServices($pagination: Pagination, $input: servicesQueryInput) {
    servicesWithPagination(pagination: $pagination, input: $input) {
      total
      items {
        id
        code
        isActive
        isDeletable
        dow
        startAt
        endAt
        businessClients {
          id
          name
          businessSites {
            id
            name
          }
        }
        confirmationModalities {
          paid
          reserved
          facebook
        }
        companyLine {
          id
          name
          company {
            id
          }
        }
        itinerariesSchedule {
          id
          startAt
          endAt
          dow
          route {
            id
            stops {
              id
            }
          }
          itinerary {
            placeID
            departure {
              time
              day
            }
            arrival {
              time
              day
            }
          }
        }
        vehiclesSchedule {
          id
          vehicle {
            id
            name
            externalID
          }
          driver {
            id
            userAccount {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`)
